<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'shared.comments.step',
  props: {
    value: { type: Object, default: () => {} }
  },
  data: vm => ({
    form: {
      comments: '',
      ...vm.value
    }
  }),

  methods: {
    validate () {
      this.$emit('validated', { ...this.form })
      this.$emit('input', { ...this.form })

      return true
    }
  }
}
</script>
<template>
  <b-card no-body class="shadow-none">
    <b-form-textarea
      id="comments"
      placeholder="Extra comments or requirements"
      v-model="form.comments"
      rows="4"
      max-rows="4"
    />
  </b-card>
</template>
